import { SM } from '@liveauctioneers/hammer-ui-core/spacing';
import { useRef } from 'react';

import AutomatedCatalogCarouselCardCatalogInfo from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/CatalogInfo/AutomatedCatalogCarouselCardCatalogInfo';
import AutomatedCatalogCarouselCardItemImages from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/ItemImages/AutomatedCatalogCarouselCardItemImages';
import { useTrackAndNavigateCatalogCardClick } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/hooks/useTrackAndNavigateCatalogCardClick';
import { useTrackCardVisibility } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/hooks/useTrackCardVisibility';

const FEATURED_CATALOG_CARD_MOBILE_SIZE_OFFSET = 10;

type Props = {
    catalogId: number;
    width: number;
};

const AutomatedCatalogCarouselCardMobile = ({ catalogId, width }: Props) => {
    const cardRef = useRef<HTMLDivElement>(null);

    const trackCardClick = useTrackAndNavigateCatalogCardClick(catalogId);
    useTrackCardVisibility({ cardRef, catalogId });

    return (
        <section
            className="h-[330px] gap-xs bg-gradient-to-b from-background-info-dark to-surface-900 p-sm hover:cursor-pointer"
            data-testid="featuredAuctionsCarousel.mobileCard"
            onClick={trackCardClick}
            ref={cardRef}
            role="link"
            style={{
                maxWidth: width - FEATURED_CATALOG_CARD_MOBILE_SIZE_OFFSET,
                width: width - FEATURED_CATALOG_CARD_MOBILE_SIZE_OFFSET,
            }}
        >
            <AutomatedCatalogCarouselCardCatalogInfo catalogId={catalogId} />
            <SM />
            <AutomatedCatalogCarouselCardItemImages catalogId={catalogId} />
        </section>
    );
};

export default AutomatedCatalogCarouselCardMobile;
